'use client';
import { useParams, useSelectedLayoutSegments } from 'next/navigation';

import { useAuthToken } from '@/store/auth';
import { routerService } from '@/services/router.service';
import { profilePanelService } from '@/services/profile-panel.service';
import { useObservableState } from '@nf/utils-common/hooks';

import { AppbarContent } from './components/appbar-content';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';


const HIDDEN_ROUTES = ['/intro', '/widget', '/jackpot', '/golden-duel', '/score-challenge', '/wc-promotion'];

export const Appbar = () => {
	const params = useParams();
	const selectedLayoutSegments = useSelectedLayoutSegments();
	const authToken = useAuthToken();
	const isMePageOpened = useObservableState(profilePanelService.onProfilePanel$, false);
	const view = useAppearanceStore(state => state.view);

	if (!authToken || view === ViewEnum.galaxy) return null;

	const isSingleMatchPage = params.matchId !== undefined;
	const pathSegments = selectedLayoutSegments.map(segment => `/${segment}`);
	const isHiddenPageRoute = HIDDEN_ROUTES.some(route => pathSegments.includes(route));

	const isBetsCanBack = routerService.checkCanBack('/bets');
	const isMePageCanBack = profilePanelService.checkCanBack();

	if (
		isSingleMatchPage || 
		isHiddenPageRoute ||
		(pathSegments.includes('/bets') && isBetsCanBack) ||
		(isMePageOpened && isMePageCanBack)
	) {
		return null;
	}

	return <AppbarContent pathSegments={pathSegments} />;
};